<template>
  <div id="personAuth">
    <div class='title'>
     <el-page-header @back="goBack" content="个人认证"> </el-page-header>
    </div>
    <div class="personAuthBox">
      <div>
        <div>
          <el-form
            :model="personAuthForm"
            ref="personAuthForm"
            label-width="150px"
            size="small"
            class="demo-personAuthForm"
          >
            <div>
              <el-form-item label="姓名:">
                <div class="addressFormItem">
                  <div class="addressFormInputItem">
                    <el-input
                      v-model="personAuthForm.realName.value"
                      @blur="inputBlur"
                      placeholder="请输入您的真实姓名"
                    ></el-input>
                  </div>
                  <span
                    v-if="personAuthForm.realName.warning"
                    class="warning"
                  >{{personAuthForm.realName.warning}}</span>
                </div>
              </el-form-item>
              <el-form-item label="身份证号:">
                <div class="addressFormItem">
                  <div class="addressFormInputItem">
                    <el-input
                      @blur="inputBlur"
                      v-model="personAuthForm.ID_card.value"
                      placeholder="请输入您的身份证号"
                    ></el-input>
                  </div>
                  <span
                    v-if="personAuthForm.ID_card.warning"
                    class="warning"
                  >{{personAuthForm.ID_card.warning}}</span>
                </div>
              </el-form-item>
              <el-form-item label="性别:">
                <div class="addressFormItem">
                  <div class="addressFormInputItem">
                    <el-radio v-model="personAuthForm.sex.value" label="1">男</el-radio>
                    <el-radio v-model="personAuthForm.sex.value" label="0">女</el-radio>
                  </div>
                  <span
                    v-if="personAuthForm.sex.warning"
                    class="warning"
                  >{{personAuthForm.sex.warning}}</span>
                </div>
              </el-form-item>

              <el-form-item label="身份证正面照:">
                <div class="addressFormItem">
                  <div class="addressFormInputItem">
                    <UploadFile @uploadSuccess="getFrontCardImg" />
                  </div>
                  <span
                    v-if="personAuthForm.front_img.warning"
                    class="warning"
                  >{{personAuthForm.front_img.warning}}</span>
                </div>
              </el-form-item>
              <el-form-item label="身份证反面照:">
                <div class="addressFormItem">
                  <div class="addressFormInputItem">
                    <UploadFile @uploadSuccess="getBackCardImg"></UploadFile>
                  </div>
                  <span
                    v-if="personAuthForm.reverse_img.warning"
                    class="warning"
                  >{{personAuthForm.reverse_img.warning}}</span>
                </div>
              </el-form-item>
              <el-form-item label="手持身份证正面照:">
                <div class="addressFormItem">
                  <div class="addressFormInputItem">
                    <UploadFile @uploadSuccess="getHandCardImg"></UploadFile>
                  </div>
                  <span
                    v-if="personAuthForm.hand_cardimg.warning"
                    class="warning"
                  >{{personAuthForm.hand_cardimg.warning}}</span>
                </div>
              </el-form-item>
              <el-form-item>请上传有效期内的身份证照片(只用于身份验证),享受更多权益</el-form-item>
              <el-form-item>
                <el-button type="primary" @click="submitForm('personAuthForm')">提交认证</el-button>
              </el-form-item>
            </div>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PageSearchTitle from "@/components/components/PageSearchTitle";
import { newAddPersonAuth } from "@/api/api";
import city from "@/utils/city.js";
import { mapState } from "vuex";
export default {
  created() {
    this.city = city;
  },
  computed: {
    ...mapState(["userInfo"])
  },
  data() {
    return {
      active: 0,
      personAuthForm: {
        realName: {
          value: "",
          reg: [{ rule: /\S/, info: "*姓名不能为空" }],
          warning: ""
        },
        ID_card: {
          value: "",
          reg: [
            {
              rule: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
              info: "*身份证号格式有误"
            },
            { rule: /\S/, info: "*身份证号不能为空" }
          ],
          warning: ""
        },
        sex: {
          value: "1",
          reg: null,
          warning: ""
        },

        front_img: {
          value: "",
          reg: [{ rule: /\S/, info: "*请上传身份证正面照" }],
          warning: ""
        },
        reverse_img: {
          value: "",
          reg: [{ rule: /\S/, info: "*请上传身份证反面照" }],
          warning: ""
        },
        hand_cardimg: {
          value: "",
          reg: [{ rule: /\S/, info: "*请上传手持身份证正面照" }],
          warning: ""
        }
      }
    };
  },
  methods: {
    goBack(){
      this.$router.go(-1)
      
    },
    submitForm(formName) {
      if (this.testForm(this.personAuthForm)) {
        this.addPersonAuth();
      }
    },
    inputBlur() {
      this.testForm(this.personAuthForm, 1);
    },
    
    addPersonAuth() {
      let url = newAddPersonAuth;
      let {
        realName,
        sex,
        ID_card,
        front_img,
        reverse_img,
        hand_cardimg
      } = this.personAuthForm;

      let data = {
        realName: realName.value,
        sex: sex.value,
        ID_card: ID_card.value,
        front_img: front_img.value,
        reverse_img: reverse_img.value,
        hand_cardimg: hand_cardimg.value,
        access_token: this.userInfo.access_token
      };
      console.log("data", data);
      let param = new URLSearchParams();
      for (var k in data) {
        param.append(k, data[k]);
      }
      this.$axios({
        method: "post",
        data: param,
        url
      })
      .then(res => {
          console.log(res);
          if (res.data.resultCode == 1) {
            this.$alert("个人认证已提交,审核结果将在三个工作日内反馈", {
              center: true,
              showClose: false,
              callback:(action)=>{
                this.$router.go(-1)
              }
            })
      
          } else {
            this.$alert(res.data.resultMsg);
          }
        })
        .catch(err => {
          alert(JSON.stringify(err));
        });
    },
    getFrontCardImg({ url }) {
      //   alert(1);

      this.personAuthForm.front_img.value = url;
      this.$nextTick(() => {
        this.inputBlur();
      });
    },
    getBackCardImg({ url }) {
      console.log(url);

      this.personAuthForm.reverse_img.value = url;
      this.$nextTick(() => {
        this.inputBlur();
      });
    },
    getHandCardImg({ url }) {
      this.personAuthForm.hand_cardimg.value = url;
      this.$nextTick(() => {
        this.inputBlur();
      });
    },
    testForm(form, type) {
      console.log("form", form);
      let flag = true;
      for (var k in form) {
        let { value, reg, warning } = form[k];
        if (reg) {
          if (type) {
            if (warning) {
              let showTips = [];
              reg.forEach(item => {
                console.log(1);
                if (!item.rule.test(value)) {
                  form[k].warning = item.info;
                  flag = false;
                  showTips.push(true);
                  console.log(k, value);
                } else {
                  showTips.push(false);
                }
              });
              console.log(showTips);
              showTips.every(item => item == false) && (form[k].warning = "");
            }
            //   alert(1)
          } else {
            // alert(2)
            let showTips = [];
            reg.forEach(item => {
              console.log(1);
              if (!item.rule.test(value)) {
                form[k].warning = item.info;
                flag = false;
                showTips.push(true);
                console.log(k, value);
              } else {
                showTips.push(false);
              }
            });
            console.log(showTips);
            showTips.every(item => item == false) && (form[k].warning = "");
          }
        }
      }
      return flag;
    }
  },
  components: {
    PageSearchTitle
  }
};
</script>

<style lang='less' scoped>
.steps {
  height: 50px;
  //   background-color: blue;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  // text-align: right
}
.addressInfoWayItems:hover  {
  cursor: pointer;
}
.addressInfoWayItems:hover  {
  cursor: pointer;
}
  .addressFormInputItem  {
  width: 300px;
}

  .addressFormItem  {
  display: flex;
}
  .warning  {
  color: #f40;
  margin-left: 10px;
}

.addressTitle  {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 60px;
  background-color: yellow;
}
  .addressTitleLeft  {
  font-size: 16px;
  font-weight: 700;
}
  .first  {
  margin: 15px 0;
}
  .addressInfoTitle  {
  height: 30px;
  background-color: purple;
  line-height: 30px;
  font-size: 14px;
  font-weight: 700;
}
  .addressInfoWay  {
  height: 50px;
  background-color: pink;
  display: flex;
  align-items: center;
}
  .addressInfoWayItems  {
  width: 150px;
  height: 30px;
  box-sizing: border-box;
  margin-right: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  border: 1px solid #aaa;
}
 .checked  {
  border-color: #f40;
}
.title{
  font-size: 16px;
  font-weight: 700;
  color:#454545;
  padding:10px;
  margin-bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/Authen/PersonAuth.vue